import { SkeletonLoader } from '../Common/SkeletonLoader';

/**
 * Footer-shaped skeleton — top divider, "Powered by Appcharge" placeholder
 * row, and the trio of footer link placeholders (privacy / refund / support).
 *
 * Used by the per-template skeletons (DEFAULT's `PaymentSkeleton`,
 * `OnePaymentSkeleton`, `PreferredPaymentSkeleton`) so the swap to the real
 * `<Footer />` lands without a layout jump.
 */
const FooterSkeleton = () => {
  return (
    <div className="w-full border-t border-base-border p-6 shrink-0">
      <div className="w-full mx-auto flex flex-col items-center gap-4">
        <SkeletonLoader width="w-36" height="h-10" />
        <div className="flex items-center gap-4">
          <SkeletonLoader width="w-20" height="h-4" />
          <SkeletonLoader width="w-20" height="h-4" />
          <SkeletonLoader width="w-14" height="h-4" />
        </div>
      </div>
    </div>
  );
};

export default FooterSkeleton;
